import { RollupConfig } from '@/types/rollup'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import useDeleteDetail, {
  UseDeleteDetailOptions,
} from '../core-hooks/useDeleteDetail'
import useGetList, { UseGetListOptions } from '../core-hooks/useGetList'
import useUpdateDetail, {
  UseUpdateDetailOptions,
} from '../core-hooks/useUpdateDetail'
import buildService from '../create-service'
import queryKeys from '../query-keys'

const service = buildService<RollupConfig>({ pathCategory: 'rollup_configs' })

export function useGetRollupConfigs({
  filters,
  ...options
}: UseGetListOptions<RollupConfig> = {}) {
  const query = useGetList<RollupConfig>({
    filters,
    queryKey: queryKeys.rollupConfigs.list({ filters }),
    serviceFn: service.getList,
    ...options,
  })

  return {
    rollupConfigs: query.allData,
    ...query,
  }
}

export function useCreateRollupConfig(
  options: UseCreateDetailOptions<RollupConfig> = {},
) {
  const mutation = useCreateDetail<RollupConfig>({
    serviceFn: service.createDetail,
    ...options,
  })

  return {
    createRollupConfig: mutation.mutate,
    createRollupConfigAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useUpdateRollupConfig(
  options: UseUpdateDetailOptions<RollupConfig> = {},
) {
  const mutation = useUpdateDetail<RollupConfig>({
    serviceFn: service.updateDetail,
    ...options,
  })

  return {
    updateRollupConfig: mutation.mutate,
    updateRollupConfigAsync: mutation.mutateAsync,
    ...mutation,
  }
}

export function useDeleteRollupConfig(options: UseDeleteDetailOptions = {}) {
  const mutation = useDeleteDetail<RollupConfig>({
    serviceFn: service.deleteDetail,
    ...options,
  })

  return {
    deleteRollupConfig: mutation.mutate,
    deleteRollupConfigAsync: mutation.mutateAsync,
    ...mutation,
  }
}
